import { atom } from 'recoil';

import type { Notification } from './types';

export const notificationState = atom<Notification | undefined>({
  key: 'notification',
  default: undefined,
});
